import script from "./VitaEmployee.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaEmployee.vue?vue&type=script&lang=ts&setup=true"

import "./VitaEmployee.vue?vue&type=style&index=0&id=4eedb6fb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eedb6fb"]])

export default __exports__